export const copyTextToClipboard = async (msg: { text: string }) => {
    const el = document.createElement('div');
    el.innerHTML = msg.text;
    const textWithoutTags = el.textContent || '';
    try {
        await navigator.clipboard.writeText(textWithoutTags);
        console.log('Text copied to clipboard');
    } catch (err) {
        console.error('Failed to copy text: ', err);
    }
};